<template>
    <div>
        <div>
            <h1 class="text-center">Moje nastavení</h1>
            <hr class="w-75 mx-auto">
        </div>
        <div class="row mt-5">
            <div class="col-12 col-md-6">
                <div>
                    <h2>Osobní nastavení</h2>
                </div>
                <div class="mt-5">
                    <label class="form-label custom_label">Emailový host</label>
                    <select class="form-select" v-model="personalPostData.email_host">
                        <option v-for="host in emailHosts" :key="host" :value="host.id">
                            {{ host.name }}
                        </option>
                    </select>
                </div>
                <div class="mt-3">
                    <label class="form-label custom_label">Odesílací adresa</label>
                    <input type="email" class="form-control custom_input" placeholder="Odesílací adresa"
                        v-model="personalPostData.email_address" />
                </div>
                <div class="mt-3">
                    <label class="form-label custom_label">Heslo od odesílací adresy</label>
                    <input type="password" class="form-control custom_input" placeholder="*********"
                        v-model="personalPostData.email_password" />
                </div>
                <div>
                    <button class="btn btn_primary px-5 mt-4" type="submit" @click="savePersonalData()">Uložit</button>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="d-flex justify-content-between align-items-center me-5">
                    <h2>Moje adresové skupiny</h2>
                    <button class="btn btn_primary" data-bs-toggle="modal" data-bs-target="#createGroup">
                        Vytvořit novou
                    </button>
                    <Popup id="createGroup" :header="'Vytvořit novou skupinu'" :editable="false" :button="'Vytvořit'"
                        @save-data="createGroup()">
                        <template v-slot:body>
                            <div>
                                <label class="form-label mt-3"><span class="text-danger">*</span>Nazev skupiny</label>
                                <input type="text" class="form-control" placeholder="Zde vložte nazev skupiny"
                                    v-model="groupPostData.name" />
                            </div>
                            <div>
                                <label class="form-label mt-3"><span class="text-danger">*</span>Adresy</label>
                                <textarea class="form-control mt-2" rows="6" placeholder="Zde vložte adresy mailů"
                                    v-model="groupPostData.addresses"></textarea>
                            </div>
                        </template>
                    </Popup>
                </div>
                <div>
                    <table class="table mt-5">
                        <thead>
                            <tr>
                                <th scope="col">Název</th>
                                <th scope="col">Počet adres</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="group in emailGroups" :key="group.id">
                                <td>{{ group.name }}</td>
                                <td>{{ group.emails_count }}</td>
                                <td data-bs-toggle="modal" data-bs-target="#viewGroup">
                                    <IconEye class="icon" @click="viewGroup(group)" />
                                </td>
                                <td>
                                    <IconTrash class="icon" @click="deleteGroup(group)" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Popup id="viewGroup" :header="'Adresy'" :editable="false">
                <template v-slot:body>
                    <div v-if="selectedGroup">
                        <span v-for="email in selectedGroup.emails" :key="email.id">{{ email.email }}<br /></span>
                    </div>
                </template>
            </Popup>
        </div>
    </div>
</template>
<script>
import Popup from '../components/Popup.vue'
import { IconEye } from '@tabler/icons-vue';
import { IconTrash } from '@tabler/icons-vue';

export default {
    components: {
        Popup,
        IconEye,
        IconTrash
    },
    data() {
        return {
            emailGroups: [],
            emailHosts: [],
            personalPostData: {
                email_address: null,
                email_password: null,
                email_host: null
            },
            groupPostData: {
                name: null,
                addresses: null
            },
            selectedGroup: null
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get('/settings').then(response => {
                this.personalPostData.email_address = response.data.settings.email_address;
                this.personalPostData.email_host = response.data.settings.email_host.id;
            })
            this.$store.getters.api.get('/settings/groups').then(response => {
                this.emailGroups = response.data.groups;
            })
            this.$store.getters.api.get('/email_hosts').then(response => {
                this.emailHosts = response.data.email_hosts;
            })
        },
        savePersonalData() {
            this.$store.getters.api.post('/settings/change', this.personalPostData).then(response => {
                if (response.status === 200) {
                    this.personalPostData.email_password = null;
                    this.loadData();
                }
            })
        },
        createGroup() {
            this.$store.getters.api.post('/settings/groups/add', this.groupPostData).then(response => {
                if (response.status === 200) {
                    this.loadData();
                }
            })
        },
        viewGroup(group) {
            this.selectedGroup = group
        },
        deleteGroup(group) {
            this.$store.getters.api.delete('/settings/groups/delete', { params: { id: group.id } }).then(response => {
                if (response.status === 200) {
                    this.loadData();
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.custom_label {
    font-weight: 600;
    font-size: 20px;
}

.custom_input {
    font-weight: 500;
    font-size: 16px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #ced4da;
    padding: 10px;
}
</style>